import areas from "./areas.svg";
import assignmentType from "./assignment-type.svg";
import creation from "./creation.svg";
import monitor from "./monitor.svg";
import notes from "./notes.svg";
import status from "./status.svg";
import templates from "./templates.svg";

const assignmentIcons = {
  areas,
  assignmentType,
  creation,
  monitor,
  notes,
  status,
  templates
};

export default assignmentIcons;
